class CreateEvaluacionAnualDto {
  constructor({
    fk_idPersonalEvaluador,
    fecha,
    cumplimientoFunciones,
    fk_idCatEstatusEvaluacion,
    fk_idCatTipoEvaluacion,
    periodoEvaluacion = '',
    promedio = '',
    observaciones = '',
    puntajeTotal = '',
    calificacion = '',
    fk_idResultado = 1,
    fk_idSupervisor = null,
    promedioValores = '',
    promedioPrincipiosConstitucionales = '',
    promedioHabilidades = '',
    evaluacionHabilidades = [],
    evaluacionPrincipios = [],
    evaluacionValores = [],
  }) {
    this.fk_idPersonalEvaluador = fk_idPersonalEvaluador
    this.periodoEvaluacion = periodoEvaluacion
    this.fecha = fecha
    this.promedio = promedio
    this.observaciones = observaciones
    this.puntajeTotal = puntajeTotal
    this.calificacion = calificacion
    this.fk_idResultado = fk_idResultado
    this.fk_idSupervisor = fk_idSupervisor
    this.fk_idCatTipoEvaluacion = fk_idCatTipoEvaluacion
    this.promedioValores = promedioValores
    this.promedioPrincipiosConstitucionales = promedioPrincipiosConstitucionales
    this.promedioHabilidades = promedioHabilidades
    this.fk_idCatEstatusEvaluacion = fk_idCatEstatusEvaluacion
    this.cumplimientoFunciones = cumplimientoFunciones
    this.evaluacionHabilidades = evaluacionHabilidades
    this.evaluacionPrincipios = evaluacionPrincipios
    this.evaluacionValores = evaluacionValores
  }

  static create(data) {
    return { ...new CreateEvaluacionAnualDto(data) }
  }
}

export default CreateEvaluacionAnualDto
